// Applications types
export const types = {

    // Redux Variable
    accounts_list: '[Accounts] list',
    roles_list: '[Roles] list',
    user_credentials: '[User] credentials',
    user_token: '[User] token',
    applications_by_account: '[Application] user applications',
    restart_redux_on_logout: '[User] logout and restart Redux',

    // Start section CONSTANTS VARIABLES
    ERROR: 'backendError',

    // Following constants are used for improve old code in the application (should be removed after refactor -taking values from REDUX-)
    USER_ROOT_ID: 1,
    USER_ADMIN_ID: 2,
    USER_TECHNICAL_ID: 3,
    USER_BASIC_ID: 4,
    
    ROLES: [
        {
            id: 1,
            name: "ROOT",
        },
        {
            id: 2,
            name: "Admin",
        },
        {
            id: 3,
            name: "Technical",
        },
        {
            id: 4,
            name: "Basic",
        }
      ],
    // End section CONSTANTS VARIABLES
}

export default types;